module.exports = "/images/bernard-fu.jpg?841d1942514487a805296a681f1ca612";